export default {
    name: 'StafetActions',
    props: {
        nextStepCallback: {
            type: Function,
            required: false
        },
        previousStepCallback: {
            type: Function,
            required: false
        },
        nextStepLabel: {
            type: String,
            required: false,
            default: 'Videre'
        },
        previousStepLabel: {
            type: String,
            required: false,
            default: 'Tilbage'
        },
        skipStepCallback: {
            type: Function,
            required: false
        },
        skipStepLabel: {
            type: String,
            required: false,
            default: 'Spring over'
        }
    },
    setup() {}
}
